"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execScript = void 0;
const ast_1 = require("./ast");
const chrono_1 = require("./chrono");
const eval_1 = require("./eval");
const exception_1 = require("./exception");
const number_1 = require("./number");
const visitor = {
    visitDefinition(node, [context]) {
        context.define(node.id, context.pop());
    },
    visitLiteral(node, [context]) {
        context.push(node.value);
    },
    visitRecordLiteral(node, [context]) {
        context.push((0, eval_1.evalNode)(context, node));
    },
    visitSymbol(node, [context, print]) {
        let word;
        if (context.length > 0) {
            const value = context.peek();
            const id = `${value.type.toLowerCase()}:${node.id}`;
            if ((word = context.lookup(id)) != null) {
                if (word.type === "Quote") {
                    word.quote.call(context, print);
                }
                else {
                    context.push(word);
                }
                return;
            }
        }
        if ((word = context.lookup(node.id)) != null) {
            if (word.type === "Quote") {
                word.quote.call(context, print);
            }
            else {
                context.push(word);
            }
            return;
        }
        if ((0, number_1.isValidNumber)(node.id)) {
            context.push((0, number_1.parseNumberValue)(node.id));
            return;
        }
        else if ((0, chrono_1.matchesDatePattern)(node.id)) {
            context.push((0, chrono_1.parseDateValue)(node.id));
            return;
        }
        else if ((0, chrono_1.matchesTimePattern)(node.id)) {
            context.push((0, chrono_1.parseTimeValue)(node.id));
            return;
        }
        throw new exception_1.NameError(`Unrecognized symbol: \`${node.id}'`, node.position);
    },
    visitVectorLiteral(node, [context]) {
        context.push((0, eval_1.evalNode)(context, node));
    },
};
/**
 * Executes given AST nodes as statements.
 */
const execScript = (context, print, script) => {
    const arg = [context, print];
    for (const node of script) {
        (0, ast_1.visitNode)(visitor, node, arg);
    }
};
exports.execScript = execScript;
